// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

import type { AppsAppIdSdkAuthenticationSettingsResult, PublicKeyServer } from "./types";

export const isAppsAppIdSdkAuthenticationSettingsResult = objectOf<AppsAppIdSdkAuthenticationSettingsResult>({
  verification_status: number,
  config_id: string,
  pkeys: arrayOf<PublicKeyServer>(
    objectOf({
      id: string,
      rpk: string,
      kd: string,
      cat: number,
    })
  ),
});
